<template>
  <div class="wrap-creativity">
    <div class="box-nav">
      <b-container>
        <nav>
          <b-row align-h="center">
            <!-- :class="[ menu.isActive ? 'active' : '' ]" -->
            <!-- :class="[i === 0 ? 'active' : '']" -->
            <router-link
              v-for="(menu, i) in menus"
              :key="i"
              :to="{ name: menu.routeName }"
              v-b-tooltip.hover.bottom
              :title="menu.tooltips"
              :class="[ menu.active ? 'active' : '' ]"
              class="col link"
            >
              <div>
                {{ menu.title }}
              </div>
            </router-link>
          </b-row>
        </nav>
      </b-container>
    </div>

    <b-container>
      <router-view name="mainCreativity" />
    </b-container>
  </div>
</template>

<script>
export default {
  computed: {
    routeName () {
      return this.$route.name
    }
  },

  data () {
    return {
      menus: [
        {
          title: 'Program',
          routeName: 'creativity_program',
          compName: 'program',
          active: false
        },
        {
          title: 'Talk & Symposium',
          routeName: 'creativity_talk_symposium',
          compName: 'creativity_talk_symposium',

          active: false
        },
        {
          title: 'School of Creativity',
          routeName: 'creativity_school_of_creativity',
          compName: 'creativity_school_of_creativity',

          active: false
        }
      ]
    }
  },

  methods: {
    checkActive () {
      this.menus.forEach(menu => {
        menu.active = false
      })

      switch (this.$route.name) {
        case 'creativity_program':
          this.menus[0].active = true

          break

        case 'creativity_talk_symposium':
          this.menus[1].active = true

          break

        case 'creativity_talk_symposium_detail':
          this.menus[1].active = true

          break

        case 'creativity_school_of_creativity':
          this.menus[2].active = true

          break

        case 'creativity_school_of_creativity_detail':
          this.menus[2].active = true

          break
      }
    }
  },

  // Set Demo
  created () {
    if (this.$route.name === 'creativity') {
      this.$router.push({ name: 'creativity_program' })
        .catch(() => {
          this.$router.push({ name: 'creativity' })
        })
    }

    this.checkActive()
  },

  watch: {
    '$route' () {
      if (this.$route.name === 'creativity') {
        this.$router.push({ name: 'creativity_program' })
      }

      this.checkActive()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-creativity {
  .box-nav {
    background-color: $light;

    .container {
      nav {
        .row {
          .link {
            display: flex;
            justify-content: center;
            align-items: center;
            width: auto;
            height: 62px;
            cursor: pointer;

            div {
              text-align: center;
              font-size: 1.25rem;
              line-height: 1;

              @media only screen and (min-width: $break-l) {
                font-size: 1.5rem;
              }
            }
          }

          .active {
            padding-top: 3px;
            border-bottom: 3px solid $active;
          }

          // .router-link-active {
          //   padding-top: 3px;
          //   border-bottom: 3px solid $active;
          // }
        }
      }
    }
  }
}
</style>
